import React from "react";

const lampList = [
  "lamp-1",
  "lamp-2",
  "lamp-3",
  "lamp-4",
  "lamp-5",
  "lamp-6",
  "lamp-7",
  "lamp-8",
  "lamp-9",
  "lamp-10",
  "lamp-11",
  "lamp-12",
  "lamp-13",
  "lamp-14",
  "lamp-15",
  "lamp-16",
  "lamp-17",
  "lamp-18",
];

const whileSpinning = (isSpinning, index) => {
  return (
    <>
      <div className={`spinnerLamp__item ${isSpinning ? "spinning" : ""}`}>
        <div className="spinnerLamp__item--inner">
          <div className="spinnerLamp__item--house">
            <span className="houseDimension"></span>
          </div>
          <div className="spinnerLamp__item--light"></div>
        </div>
      </div>
      <div className={`spinnerLamp__item ${isSpinning ? "spinning" : ""}`}>
        <div className="spinnerLamp__item--inner">
          <div className="spinnerLamp__item--house">
            <span className="houseDimension"></span>
          </div>
          <div className="spinnerLamp__item--light"></div>
        </div>
      </div>
    </>
  );
};

const WheelLamp = ({ isSpinning, diameter }) => {
  return (
    <div className="spinnerLamp">
      {lampList.map((lamp, index) => {
        return (
            <div
              key={index}
              className={`spinnerLamp__group lamp-${index}`}
              style={{
                transform: `translate(-50%, -50%) rotate(${index * 40}deg)`,
              }}
            >
              {whileSpinning(isSpinning, index)}
            </div>
        );
      })}
    </div>
  );
};

export default WheelLamp;
